import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Plugin } from 'prosemirror-state';
import _isEmpty from 'lodash/isEmpty';
import pluginKey from './pluginKey';
import { embedCard } from './nodes/embedCard';
import EditorReactView from '../../utils/EditorReactView';
import { getSelectedNodePosition, removeSelectedNodeByPlugin, updateSelectedNodeAttrs } from '../../utils';
import FormPopover from '../Common/components/FormPopover';
import EmbedCardView from './EmbedCardView';
import { getIconItem } from '../../utils/menu';
import { insertEmbedLink } from './actions';
const getToolbarItems = () => [{
  id: 'type',
  dropdownItems: [{
    label: 'Inline',
    value: 'inline'
  }, {
    label: 'Embed',
    value: 'embed'
  }],
  type: 'dropdown',
  valueAttrKey: 'wrapType',
  onClick: (state, dispatch, view, pluginState, wrapType) => updateSelectedNodeAttrs(state, dispatch, view, pluginState, {
    wrapType
  })
}, {
  id: 'layout',
  dropdownItems: [{
    label: 'Left',
    value: 'left'
  }, {
    label: 'Right',
    value: 'right'
  }, {
    label: 'Center',
    value: 'center'
  }],
  type: 'dropdown',
  valueAttrKey: 'layout',
  onClick: (state, dispatch, view, pluginState, layout) => updateSelectedNodeAttrs(state, dispatch, view, pluginState, {
    layout
  })
}, {
  id: 'edit-url',
  renderContent: (wrapperClass, _ref) => {
    let {
      props: {
        editorView,
        pluginState
      }
    } = _ref;
    const {
      pos
    } = pluginState || {};
    if (pos === null) {
      return false;
    }
    const node = editorView.state.doc.nodeAt(pos);
    const {
      url
    } = node.attrs;
    return /*#__PURE__*/React.createElement(FormPopover, {
      popoverProps: {
        title: 'Edit Url'
      },
      formItems: [{
        name: 'url',
        inputProps: {
          placeholder: 'Enter url',
          style: {
            width: '350px'
          }
        },
        itemProps: {
          label: 'Url'
        },
        initialValue: url,
        rules: [{
          required: true,
          message: 'Please input card url'
        }]
      }],
      onSubmit: values => updateSelectedNodeAttrs(editorView.state, editorView.dispatch, editorView, pluginState, values)
    }, /*#__PURE__*/React.createElement("div", {
      key: "edit-url",
      className: wrapperClass,
      title: "Edit Url",
      role: "button",
      tabIndex: "0"
    }, /*#__PURE__*/React.createElement("span", {
      className: "ProseMirror-icon"
    }, /*#__PURE__*/React.createElement("span", {
      className: "icon-edit"
    }))));
  }
}, {
  id: 'resize',
  renderContent: (wrapperClass, _ref2) => {
    let {
      props: {
        editorView,
        pluginState
      }
    } = _ref2;
    const {
      pos
    } = pluginState || {};
    if (pos === null) {
      return false;
    }
    const node = editorView.state.doc.nodeAt(pos);
    const {
      width,
      height
    } = node.attrs;
    return /*#__PURE__*/React.createElement(FormPopover, {
      popoverProps: {
        title: 'Resize Card'
      },
      formItems: [{
        name: 'width',
        inputProps: {
          placeholder: 'Width (in px | % | em | rem | auto)'
        },
        itemProps: {
          label: 'Width'
        },
        initialValue: width,
        rules: [{
          required: true,
          message: 'Please input card width!'
        }]
      }, {
        name: 'height',
        inputProps: {
          placeholder: 'Height (in px | % | em | rem | auto)'
        },
        itemProps: {
          label: 'Height'
        },
        initialValue: height,
        rules: [{
          required: true,
          message: 'Please input card height!'
        }]
      }],
      onSubmit: values => updateSelectedNodeAttrs(editorView.state, editorView.dispatch, editorView, pluginState, values)
    }, /*#__PURE__*/React.createElement("div", {
      key: "resize",
      className: wrapperClass,
      title: "Resize",
      role: "button",
      tabIndex: "0"
    }, /*#__PURE__*/React.createElement("span", {
      className: "ProseMirror-icon"
    }, /*#__PURE__*/React.createElement("span", {
      className: "icon-resize"
    }))));
  }
}, {
  id: 'open-link',
  title: 'Open Link in new tab',
  icon: 'tap-icon-advanced-search',
  onClick: (state, dispatch, view, pluginState) => {
    if (pluginState.attrs.url) {
      let {
        url
      } = pluginState.attrs;
      const HTTP_LINK_REGEX = /(https?:\/\/[^\s]+)/g;
      const urlMatch = url.match(HTTP_LINK_REGEX);
      if (_isEmpty(urlMatch)) {
        url = "https://".concat(url);
      }
      window.open(url);
    }
  }
}, {
  id: 'remove',
  icon: 'tap-icon-delete-fill',
  title: 'Remove',
  onClick: removeSelectedNodeByPlugin
}];
const onFilterFloatingToolbar = (view, pluginState, items) => {
  const node = view.state.doc.nodeAt(pluginState.pos);
  if (!node || node.attrs.wrapType === 'embed') return items;
  return items.filter(item => item.id !== 'resize' && item.id !== 'layout');
};
export default {
  name: 'embedCard',
  configure: options => ({
    nodes: {
      embedCard
    },
    plugin: new Plugin({
      key: pluginKey,
      props: {
        nodeViews: {
          embedCard: (node, view, getPos) => new EditorReactView(EmbedCardView, {}, node, view, getPos)
        }
      },
      state: {
        init: (_, state) => ({
          pos: getSelectedNodePosition(state, 'embedCard'),
          attrs: {},
          activeToolbarItem: 'wrap-inline'
        }),
        apply: (tr, pluginState, _oldState, newState) => {
          if (tr.docChanged || tr.selectionSet) {
            const pos = getSelectedNodePosition(newState, 'embedCard');
            const node = pos ? newState.doc.nodeAt(pos) : null;
            const newPluginState = _objectSpread(_objectSpread({}, pluginState), {}, {
              pos,
              attrs: node ? node.attrs : {}
            });
            return newPluginState;
          }
          return pluginState;
        }
      }
    }),
    menuItems: [getIconItem('insert-embed', 'tap-icon-editor-embed', 'Embed', function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      const [state, dispatch, view] = args;
      return insertEmbedLink(state, dispatch, view, options.embedPatterns);
    })],
    floatingToolbars: [{
      pluginKey,
      info: {
        items: getToolbarItems(options),
        onFilter: onFilterFloatingToolbar
      }
    }]
  })
};